import {HttpErrorResponse} from '@angular/common/http';
import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatFormField} from '@angular/material/form-field';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {
  FabDateFilterComponent, FabDateFilterOperator,
  FabNumberFilterComponent,
  FabStringFilterComponent, FabStringFilterOperator
} from '@fabric/components/table-filter';
import {FabTableState, filterStateChange, process} from '@fabric/components/table-filter/data-query';
import {catchError, forkJoin, concat, map, Observable, ObservableInput, of, tap, startWith} from 'rxjs';
import {ErrorCodes} from 'src/app/constants/ErrorCodes';
import {UserFunctionCode} from 'src/app/constants/UserFunctionCode';
import {DestinoTransportistasService} from 'src/app/services/destinoTransportista.service';
import {DestinoTransportistas} from '../../models/DestinoTransportistas';
import {NotificationService} from '../../services/notification.service';
import {SecurityService} from '../../services/security.service';
import {TransporteService} from 'src/app/services/transporte.service';
import { FormControl } from '@angular/forms';
import { VehOrigenService } from 'src/app/services/vehOrigen.service';
import { VehOrigen } from 'src/app/models/VehOrigen';
import { DestinatarioService } from 'src/app/services/destinatario.service';
import { MaintenanceTransportistaLite} from "../../models/MaintenanceTransportistaLite";

@Component({
  selector: 'app-vehicle-destino-transportista-maintenance',
  templateUrl: './vehicle-destino-transportista-maintenance.component.html',
  styleUrls: ['./vehicle-destino-transportista-maintenance.component.scss']
})
export class VehicleDestinoTransportistaMaintenanceComponent implements OnInit {


  columnsToDisplay: string[] = ["origenField", "destinoField", "transporteField", "estado", "fecCreacion", "usrCreacion",
    "fecModif", "usrModif", "isEdit"]
  dataSource: MatTableDataSource<DestinoTransportistas> = new MatTableDataSource<DestinoTransportistas>();
  rowsToModify: any = [];
  rowsToAdd: any = [];
  isLoading = false;
  origenControl = new FormControl('');
  transporteControl = new FormControl('');
  origensFromService: String[] = [];
  transportesFromService: String[] = [];

  origenMap: Map<string, string> = new Map<string, string>();
  reverseOrigenMap: Map<string, string> = new Map<string, string>();

  destinoMap: Map<string, string> = new Map<string, string>();
  reverseDestinoMap: Map<string, string> = new Map<string, string>();

  transporteMap: Map<string, string> = new Map<string, string>();
  reverseTransporteMap: Map<string, string> = new Map<string, string>();
  TABLE_DATA: DestinoTransportistas[] = [];
  ORIGINAL_TABLE_DATA: DestinoTransportistas[] = [];
  columnsSchema: any = this.columnsToDisplay;
  operators: FabStringFilterOperator[] = ['contains'];
  dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  canAddOrEdit: boolean = false;
  initialDate: string = new Date().toISOString();
  resultsLength = 0;
  pageSize = 10;
  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };
  selector: string

  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort!: MatSort;
  @ViewChildren('tableFilter') tableFilters: QueryList<FabStringFilterComponent | FabNumberFilterComponent | FabDateFilterComponent>;


  public get saveButtonDisabled() {

    return !this.validateAllRows()
      || (!this.hasDataChanged()
        && this.TABLE_DATA.filter(element => element.isAdd).length == 0);
  }

  private hasDataChanged() {
    return this.TABLE_DATA.filter(element => element.isEdit).map((row) => {
      return this.isDirtyRow(row);
    }).some(item => item);

  }

  public isDirtyAndNotAdd(row: DestinoTransportistas, column: string) {
    var toReturn;

    if (row.isAdd) {
      toReturn = false;
    } else {

      // @ts-ignore
      toReturn = (row[column] != row.originalData[column])
    }
    return toReturn;
  }

  public isDirty(row: DestinoTransportistas, column: string) {
    // @ts-ignore
    return (row[column] != row.originalData[column]);

  }


  constructor(private destinoTransportistasService: DestinoTransportistasService,
              private notificationService: NotificationService,
              private securityService: SecurityService,
              private readonly transporteService: TransporteService,
              private readonly vehOrigenService: VehOrigenService,
              private readonly destinatarioService: DestinatarioService,
              private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    this.fetchData();
    this.canAddOrEdit = this.securityService.can(UserFunctionCode.MAINTENANCE);
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.processData();
  }

  public filterChange(event: any) {
    this.state.skip = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    // @ts-ignore
    this.state.filter = filterStateChange(event, this.state.filter);
    this.processData();
  }


  getTransportes() {
    this.transporteService.getTransporteLiteTable().subscribe(
      (data: MaintenanceTransportistaLite[]) => {

        for (const row of data) {
          if(row.estado){
            this.transportesFromService.push(row.cod);
            const codAndNombre = row.cod + " - " + row.nombre
            this.transporteMap.set(codAndNombre, row.cod);
            this.reverseTransporteMap.set(row.cod, codAndNombre);
          }
        }

        this.processTableValue();

      },
      (err: string) => {
        this.notificationService.open(err, 'error');
      }
    )
  }

  getVehOrigen() {
    this.vehOrigenService.getVehOrigenTable().subscribe(
      (data: VehOrigen[]) => {

        for (const row of data) {
         this.origenMap.set(VehOrigen.combinedVehOrigen(row.codOrigen,row.descOrigen), row.codOrigen);
         this.reverseOrigenMap.set(row.codOrigen, VehOrigen.combinedVehOrigen(row.codOrigen,row.descOrigen));
        }

        this.processTableValue();

      },
      (err: string) => {
        this.notificationService.open(err, 'error');
      }
    )
  }


  getDestinatario() {
    this.destinatarioService.getDestinatarioLiteTable().subscribe(
      (data: MaintenanceTransportistaLite[]) => {

        for (const row of data) {
          if(row.estado) {
            this.destinoMap.set(row.cod + " - " + row.nombre, row.cod);
            this.reverseDestinoMap.set(row.cod, row.cod + " - " + row.nombre);
          }
        }

        this.processTableValue();

      },
      (err: string) => {
        this.notificationService.open(err, 'error');
      }
    )
  }

  public origenFilter(element: DestinoTransportistas) {
    return Array.from(this.origenMap.keys()).filter((item) => item.toUpperCase().includes(element.origenField.toUpperCase()));
  }

  public transporteFilter(element: DestinoTransportistas) {
    return Array.from(this.transporteMap.keys()).filter((item) => item.toUpperCase().includes(element.transporteField.toUpperCase()));
  }

  public destinoFilter(element: DestinoTransportistas) {
    return Array.from(this.destinoMap.keys()).filter((item) => item.toUpperCase().includes(element.destinoField.toUpperCase()));
  }



// process your local data and assign it to the datasource
// <your data> is an array of objects whose keys match up to the table columns
  private fetchData() {
    this.destinoTransportistasService.getDestinoTransportistasTable().subscribe(
      (data: any) => {

        this.dataSource.data = process(data as any[], this.state)
        for (const row of this.dataSource.data) {
          row.isEdit = false;
          row.isAdd = false;
          row.isSave = false;
          row.originalData = JSON.parse(JSON.stringify(row));
        }
        this.TABLE_DATA = data as any[];

        // Removed filter for estado as it is not needed.
        // Filter is done through SQL query in the backend to reduce response size.
        // this.TABLE_DATA = this.TABLE_DATA.filter((item) => {
        //   return item.estado
        // })

        this.getTransportes();
        this.getVehOrigen();
        this.getDestinatario();
        this.processTableValue()

        this.sortTableById();

        this.processData();

      },
      (err: string) => {
        this.notificationService.open(err, 'error');
      }
    )
  }

  processTableValue(){
    for (const row of this.dataSource.data) {
      const origenField = this.reverseOrigenMap.get(row.origen);
      if(origenField != undefined){
        row.origenField = origenField;
      }

      const destinoField = this.reverseDestinoMap.get(row.destinoCode);
      if(destinoField != undefined){
        row.destinoField = destinoField;
      }

      const transporteField = this.reverseTransporteMap.get(row.codTransp);
      if(transporteField != undefined){
        row.transporteField = transporteField;
      }

      row.originalData = JSON.parse(JSON.stringify(row));
    }
  }

  onOrigenChange(element : DestinoTransportistas, control: MatFormField){
    const newField = this.origenMap.get(element.origenField);
    if (newField) {
      element.changeOrigen(newField);
    } else {
      element.origen = "";
    }

    this.checkInputIsInDropdown(element,control,"origen");
    this.checkId(element, control);
  }

  onDestinoChange(element : DestinoTransportistas, control: MatFormField){
    const newField = this.destinoMap.get(element.destinoField);
    if (newField) {
      element.changeDestino(newField);
    } else {
      element.destinoCode = "";
    }
    this.checkInputIsInDropdown(element,control,"destino");
    this.checkId(element, control);
  }


  onTransporteChange(element : DestinoTransportistas, control: MatFormField){
    const newField = this.transporteMap.get(element.transporteField);
    if (newField) {
      element.changeTransporte(newField);
    } else {
      element.codTransp = "";
    }
    this.checkInputIsInDropdown(element,control,"transporte");
  }


  processData() {
    this.dataSource.data = process(this.TABLE_DATA, this.state);
  }

  sortDataByModif() {
    this.TABLE_DATA.sort(function (a, b) {
      var va = (a.fecModif === undefined || null) ? new Date(a.fecCreacion) : new Date(a.fecModif),
        vb = (b.fecModif === undefined || null) ? new Date(b.fecCreacion) : new Date(b.fecModif);

      // @ts-ignore
      return vb - va;
    });
  }

  sortTableById() {
    this.TABLE_DATA.sort((a, b) => {
      // @ts-ignore
      return b.id - a.id;
    });
  }


  addRow() {
    console.log("add row");
    let newRow = new DestinoTransportistas;
    newRow.estado = true;
    newRow.isAdd = true;
    newRow.isSave = true;
    newRow.usrCreacion = this.securityService.LOGGED_USER['gmin'];
    this.dataSource.data.unshift(newRow);

    this.processData();
  }


  editRow(row: DestinoTransportistas) {
    console.log("edit row");
    if (!row.isAdd) {
      row.isEdit = true;
      row.isSave = true;
      row.usrModif = this.securityService.LOGGED_USER['gmin'];
    }

    if (row.isAdd) {
      row.isEdit = true;
    }
    console.log(row);
  }


  cancelRow(row: DestinoTransportistas) {
//    //"origen", "destinoCode", "destinoDescription", "codTransp"
    if (row.isAdd) {
      this.TABLE_DATA = this.TABLE_DATA.filter((item) => {
        return item !== row;
      })
    } else {
      row.origen = row.originalData.origen;
      row.codTransp = row.originalData.codTransp;
      row.destinoCode = row.originalData.destinoCode;
      // row.destinoDescription = row.originalData.destinoDescription;
      row.estado = row.originalData.estado;

      const origenField = this.reverseOrigenMap.get(row.origen);
      if(origenField != undefined){
        row.origenField = origenField;
      }

      const destioField = this.reverseDestinoMap.get(row.destinoCode);
      if(destioField != undefined){
        row.destinoField = destioField;
      }

      const transporteField = this.reverseTransporteMap.get(row.codTransp);
      if(transporteField != undefined){
        row.transporteField = transporteField;
      }


      row.usrModif = "";
      row.isEdit = false;
      row.isSave = false;
    }


    this.processData();
  }


  save() {
    let inactiveObservables: ObservableInput<any>[] = [];
    let activeObservables: ObservableInput<any>[] = [];
    let errors: HttpErrorResponse[] = [];
    let saved = 0;
    let firstValidation: Boolean = this.validateAllRows();
    if (firstValidation) {
      this.TABLE_DATA.filter((item) => item.isSave)
        .forEach((row) => {
            if (this.isDirtyRow(row) || row.isAdd) {
              let observableType = row.estado ? activeObservables : inactiveObservables;
              observableType.push(
                this.destinoTransportistasService.addUpdate(row, row.isAdd)
                  .pipe(
                    map((res: DestinoTransportistas) => {
                      row.originalData = res;
                      row.isEdit = false;
                      row.isAdd = false;
                      row.isSave = false;
                      row.id = res.id;
                      row.fecModif = res.fecModif;
                      saved++;
                    }),
                    catchError((err: HttpErrorResponse) => {
                      errors.push(err);
                      return of(null);
                    })
                  )
              );
            }
          }
        );

        concat(forkJoin(inactiveObservables), forkJoin(activeObservables)).subscribe({
        next: undefined,
        error: undefined,
        complete: () => {
          if (errors.length == 0) {
            this.notificationService.open(ErrorCodes.SAVED, 'success');
            this.sortTableById();
            this.processData();
          } else {
            const errorCounts = errors.map(err => err.error.errorMessage).reduce((accumulator, value) => {
              // @ts-ignore
              return {...accumulator, [value]: (accumulator[value] || 0) + 1};
            }, {});
            let errorMessage = `${saved} rows saved. ${errors.length} rows have errors:`
              .concat(...Object.entries(errorCounts).map(([msg, count]) => `\n${msg} (${count})`));
            this.notificationService.open(errorMessage, 'error');
          }
        }
      });
    } else {
        this.notificationService.open(ErrorCodes.INVALID_DATA, 'error');
    }
  }


  private validateRow(row: DestinoTransportistas) {

    return (row.destinoCode != null && row.destinoCode.length > 0 && Array.from(this.reverseDestinoMap.keys()).includes(row.destinoCode)) &&
      (row.codTransp != null && row.codTransp.length > 0 && Array.from(this.reverseTransporteMap.keys()).includes(row.codTransp)) &&
      (row.origen != null && row.origen.length > 0 && Array.from(this.reverseOrigenMap.keys()).includes(row.origen)) &&
      !this.origenDestinoPairExistsInTable(row);

  }

  origenDestinoPairExistsInTable(row: DestinoTransportistas) {
    if (row.estado) {
      return this.TABLE_DATA.filter((element) => {
        return row != element &&
          row.origen == element.origen &&
          row.destinoCode == element.destinoCode &&
          element.estado;

      }).length > 0;
    } else {
      return false;
    }
  }

  public validateAllRows() {
    return this.TABLE_DATA.filter(element => element.isEdit).every((row) => this.validateRow(row))
      && this.TABLE_DATA.filter(element => element.isAdd).every((row) => this.validateRow(row));
  }


  private dirtyCheck(): boolean {
    return !this.TABLE_DATA.every((row) => {
      return !row.isEdit;
    })
  }

  checkInputIsInDropdown(row: DestinoTransportistas, control: MatFormField, type: String){
    var isValid = true;

    if(type == "origen"){
      isValid = Array.from(this.reverseOrigenMap.keys()).includes(row.origen);
    } else if(type == "destino"){
      isValid = Array.from(this.reverseDestinoMap.keys()).includes(row.destinoCode);
    } else if(type == "transporte"){
      isValid = Array.from(this.reverseTransporteMap.keys()).includes(row.codTransp);
    }

    if(!isValid){
      control._control.ngControl?.control?.setErrors({'id-already-exists':true});
    }


  }

  checkId(row: DestinoTransportistas, control: MatFormField) {
    if (this.origenDestinoPairExistsInTable(row)) {
      this.notificationService.open(ErrorCodes.DUPLICATE_DESTINO_TRANSPORTISTA, "warn");
      control._control.ngControl?.control?.setErrors({'id-already-exists':true});
    }
  }


  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.dirtyCheck()) {
      return confirm("You have unsaved changes. Leave page anyway?");
    } else {
      return true;
    }
  }


  private isDirtyRow(row: DestinoTransportistas) {

    const keys = Object.keys(row) as (keyof DestinoTransportistas)[];
    return keys.map((key) => {
      if (key !== 'isSave' && key !== 'isEdit' && key !== 'originalData') {
        let dataChanged = this.isDirtyAndNotAdd(row, key);
        return dataChanged;
      } else {
        return false;
      }
    }).some(item => item);

  }
}
